import React from "react";

import { Navbar } from "../../../components";
import { Agile } from "./Agile";

const AgileProject = () => {
  return (
    <div className="app">
      <Navbar />
      <Agile />
    </div>
  );
};

export default AgileProject;
